import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppState } from '../../store/app.state';
import { userSettingsFeature } from '../../store/state/user-settings/user-settings.feature';
import { UiHeaderWithBreadcrumbsComponent } from '@ui';
import { routeFeature } from '../../store/state/route/route.reducer';
import { async, Observable } from 'rxjs';
import { RouteModels } from '@share-models';
import { AsyncPipe, NgIf } from '@angular/common';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  imports: [RouterOutlet, SidebarComponent, UiHeaderWithBreadcrumbsComponent, AsyncPipe, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit {

  private readonly destroyRef = inject(DestroyRef);
  private readonly store = inject(Store<AppState>);

  private readonly darkThemeClassName = 'dark-theme';
  private readonly lightThemeClassName = 'light-theme';

  public searchQuery = '';

  public selectBreadcrumbs$: Observable<RouteModels.UiBreadCrumbItem[] | null> = this.store.select(routeFeature.selectBreadcrumbs);

  public ngOnInit(): void {
    this.store
      .select(userSettingsFeature.selectTheme)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((theme) => {
        this.syncBodyTheme(theme);
      });


  }

  private syncBodyTheme(theme: 'light' | 'dark'): void {
    const isDarkTheme = theme === 'dark';
    document.body.classList.toggle(this.darkThemeClassName, isDarkTheme);
    document.body.classList.toggle(this.lightThemeClassName, !isDarkTheme);
  }

  protected readonly async = async;
}
